module.exports = function deprecate(fn, message) {
  var warned = false;

  function deprecated() {
    if (!warned) {
      /* eslint no-console:0 */
      console.warn(message);
      warned = true;
    }

    return fn.apply(this, arguments);
  }

  return deprecated;
};



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/deprecate.js
// module id = 16
// module chunks = 0